import DishCard from './DishCard'
export default DishCard
